import { TouchSwipe } from '../touchSwipe'

export class SlideShowComponent {

    constructor() {
        this.slideshowContainer = document.querySelector('.slideshow');
        this.slideshow = document.querySelector('.slideshow__slides');
        this.slides = (this.slideshow) ? this.slideshow.querySelectorAll('.slide') : undefined;
        this.arrowPrevious = (this.slideshowContainer) ? this.slideshowContainer.querySelector('.slideshow__previous') : undefined;
        this.arrowNext = (this.slideshowContainer) ? this.slideshowContainer.querySelector('.slideshow__next') : undefined;
		this.indicatorsContainer = (this.slideshowContainer) ? this.slideshowContainer.querySelector('.slideshow__indicators') : undefined;
		this.thumbsContainer = (document.querySelector('#slideshow__thumbs')) ? document.querySelector('#slideshow__thumbs') : undefined;
		this.app = {};
		this.defaults = {
            delay: 7500,
            arrows: true,
			indicators: true,
			thumbs: ((document.querySelector('#slideshow__thumbs')) ? true : false),
            random: false,
            slideshow: true,
            animationSpeed: '1s'
		};

        //initialize
        this.init();

    }

    // check properties
	checkProperties() {

		var random = (this.defaults.random) ? _randomInt(0, this.slides.length - 1) : 0;

		for(var i=0; i<this.slides.length; i++) {

            if(i === random) { this.slides[i].className += ' slide--active'; }

			this.setVendor(this.slides[i], 'Transition', this.defaults.animationSpeed);

		}

	}



	// slideshow function
	slideShowFn() {
		var active = this.slideshow.querySelector('.slide--active');
		var next = (this.nextElement(active)) ? this.nextElement(active) : this.slides[0];

		// classes
		active.className = 'slide';
		next.className += ' slide--active';

		// indicators
		if(this.defaults.indicators) {
			var activePointer = this.indicatorsContainer.querySelector('.slideshow__indicator--active');
			var nextPointer = (this.nextElement(activePointer)) ? this.nextElement(activePointer) : this.app.indicators[0];
			activePointer.className = activePointer.className.replace(/(?:^|\s)slideshow__indicator--active(?!\S)/g, '');
			nextPointer.className += ' slideshow__indicator--active';
		}

		// thumbs
		if(this.defaults.thumbs) {
			var activePointer = this.thumbsContainer.querySelector('.slideshow__thumb--active');
			var nextPointer = (this.nextElement(activePointer)) ? this.nextElement(activePointer) : this.app.thumbs[0];
			activePointer.className = activePointer.className.replace(/(?:^|\s)slideshow__thumb--active(?!\S)/g, '');
			nextPointer.className += ' slideshow__thumb--active';
		}

	}

	// Previous slide
	previousSlide() {

		this.stopSlideshow();

		var active = this.slideshow.querySelector('.slide--active');
		var previous = (this.previousElement(active) ? this.previousElement(active) : this.slides[this.slides.length - 1]);

		// classes
		active.className = 'slide';
		previous.className += ' slide--active';

		// indicators
		if(this.defaults.indicators) {
			var activePointer = this.indicatorsContainer.querySelector('.slideshow__indicator--active');
			var nextPointer = (this.previousElement(activePointer)) ? this.previousElement(activePointer) : this.app.indicators[this.app.indicators.length - 1];
			activePointer.className = activePointer.className.replace(/(?:^|\s)slideshow__indicator--active(?!\S)/g, '');
			nextPointer.className += ' slideshow__indicator--active';
		}

		// thumbs
		if(this.defaults.thumbs) {
			var activePointer = this.thumbsContainer.querySelector('.slideshow__thumb--active');
			var nextPointer = (this.previousElement(activePointer)) ? this.previousElement(activePointer) : this.app.thumbs[this.app.thumbs.length - 1];
			activePointer.className = activePointer.className.replace(/(?:^|\s)slideshow__thumb--active(?!\S)/g, '');
			nextPointer.className += ' slideshow__thumb--active';
		}

		if(this.defaults.slideshow && (this.thumbsContainer === undefined)) {
			this.startSlideshow();
		}

	}

	// Next slide
	nextSlide() {

		this.stopSlideshow();

		this.slideShowFn();

		if(this.defaults.slideshow && (this.thumbsContainer === undefined)) {
			this.startSlideshow();
		}

	}

	// create indicators and add event listeners
	createIndicators() {

		for(var i=0; i<this.slides.length; i++) {
			var node = document.createElement("div");
			node.setAttribute("data-index", i);
			var indicators = this.indicatorsContainer.appendChild(node);
			indicators.addEventListener("click", (e) => this.indicatorsClick(e.target.getAttribute("data-index")));
			indicators.className = 'slideshow__indicator';
			if(this.hasClass(this.slides[i], 'slide--active')) {
				indicators.className += ' slideshow__indicator--active';
			}

			if(this.defaults.thumbs) {
				var node = document.createElement("img");
				node.setAttribute("data-index", i);
				node.src = this.slides[i].getAttribute('data-src');
        node.alt = this.slides[i].getAttribute('data-alt');
				var thumbs = this.thumbsContainer.appendChild(node);
				thumbs.addEventListener("click", (e) => this.indicatorsClick(e.target.getAttribute("data-index")));
				thumbs.className = 'slideshow__thumb';
				if(this.hasClass(this.slides[i], 'slide--active')) {
					thumbs.className += ' slideshow__thumb--active';
				}
			}
		}

		this.app.indicators = this.slideshowContainer.querySelectorAll('.slideshow__indicator');

		if(this.defaults.thumbs) {
			this.app.thumbs = document.querySelectorAll('.slideshow__thumb');
		}

	}

	// indicators click function
	indicatorsClick(index) {

		this.stopSlideshow();

		// remove active classes
		for(var i=0; i<this.slides.length; i++) {
			if(this.hasClass(this.app.indicators[i], 'slideshow__indicator--active')) {
				this.app.indicators[i].className = this.app.indicators[i].className.replace(/(?:^|\s)slideshow__indicator--active(?!\S)/g, '');
			}
			if(this.defaults.thumbs) {
				if(this.hasClass(this.app.thumbs[i], 'slideshow__thumb--active')) {
					this.app.thumbs[i].className = this.app.thumbs[i].className.replace(/(?:^|\s)slideshow__thumb--active(?!\S)/g, '');
				}
			}
			if(this.hasClass(this.slides[i], 'slide--active')) {
				this.slides[i].className = 'slide';
			}
		}

        // add active class
		var i = index;
		this.app.indicators[i].className += ' slideshow__indicator--active';

		if(this.defaults.thumbs) {
			this.app.thumbs[i].className += ' slideshow__thumb--active';
		}

		// add classes to slide
		this.slides[i].className += ' slide--active';

		if(this.defaults.slideshow && (this.thumbsContainer === undefined)) {
			this.startSlideshow();
		}

	}

	// start slideshow
	startSlideshow() {

		this.app.intervalSliding = setInterval(() => this.slideShowFn(), this.defaults.delay);
	}

	// stop slideshow
	stopSlideshow() {

		clearInterval(this.app.intervalSliding);
	}

	// set browser vendor properties
	setVendor(element, property, value) {
	  element.style["webkit" + property] = value + ' ease-in-out';
	  element.style["Moz" + property] = value + ' ease-in-out';
	  element.style["ms" + property] = value + ' ease-in-out';
	  element.style["o" + property] = value + ' ease-in-out';
	}

	// has class
	hasClass(element, cls) {
    	return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
	}

	// Next element
	nextElement(element) {
	    do {
	        element = element.nextSibling;
	    } while (element && element.nodeType !== 1);

	    return element;
	}

	// Previous element
	previousElement(element) {
	    do {
	        element = element.previousSibling;
	    } while (element && element.nodeType !== 1);

	    return element;
	}

	// Random number
	randomInt(min, max) {

    	return Math.floor(Math.random() * (max - min + 1) + min);
    }

    init() {

		if( ! this.slideshowContainer) { return false; }

		//remove default height
		this.slideshow.classList.remove("slideshow__slides--preload");

		this.checkProperties();

		if(this.slides.length > 1) {

			new TouchSwipe(this.slideshow, (direction) => {
				if(direction === 'left')
					this.previousSlide()

				else if(direction === 'right')
					this.nextSlide()
			})

			if(this.defaults.arrows) {

				this.arrowNext.addEventListener('click', () => this.nextSlide());
				this.arrowPrevious.addEventListener('click', () => this.previousSlide());
				this.arrowPrevious.style.display = 'block';
				this.arrowNext.style.display = 'block';
			}

			if(this.defaults.indicators) {
				this.createIndicators();
			}

			if(this.defaults.slideshow && (this.thumbsContainer === undefined)) {
				this.startSlideshow();
			}
		}

	}
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/slideshow/slideshow.component.js